import Scatter from './Scatter';
import './Scatter.scss';
import '../../../components/Tooltip/styles.scss';
export default Scatter;
